import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 查询列表
export const setKeywords: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情(物品或材料列表)
export const setKeywordSubList: Mutation<IModuleState> = (state, payload) => {
  state.subList.data = payload.data;
  state.subList.pageNum = payload.pageNum;
  state.subList.pageSize = payload.pageSize;
  state.subList.total = payload.total;
  state.subList.loading = !!payload.loading;
};

export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.title = payload.title;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};
